// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d-col {
  display: flex;
  flex-direction: column;
}

.tab-forms-container {
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2588235294);
  margin: 10px;
  max-width: 600px;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  padding: 2rem 3rem;
}

.tab-forms-center {
  display: flex;
  justify-content: center;
}

.create-account-form-group {
  display: flex;
  flex-direction: row;
  text-align: center;
  margin-bottom: 15px;
}

.create-account-label {
  width: 30%;
  justify-content: flex-end;
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.create-account-form-field {
  width: 70%;
}

.d-row {
  display: flex;
  flex-direction: row;
}

.align-items-center {
  align-items: center;
}

.justify-content-end {
  justify-content: flex-end;
}

.justify-content-between {
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/account/components/create-account/create-account.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,kDAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,8BAAA;AACJ","sourcesContent":[".d-col {\n    display: flex;\n    flex-direction: column;\n}\n\n.tab-forms-container {\n    box-shadow: 0 5px 10px #00000042;\n    margin: 10px;\n    max-width: 600px;\n    width: 100%;\n    height: fit-content;\n    padding: 2rem 3rem;\n}\n\n.tab-forms-center {\n    display: flex;\n    justify-content: center;\n}\n\n.create-account-form-group {\n    display: flex;\n    flex-direction: row;\n    text-align: center;\n    margin-bottom: 15px;\n}\n\n.create-account-label {\n    width: 30%;\n    justify-content: flex-end;\n    margin-right: 10px;\n    display: flex;\n    align-items: center;\n}\n\n.create-account-form-field {\n    width: 70%;\n}\n\n.d-row {\n    display: flex;\n    flex-direction: row;\n}\n\n.align-items-center {\n    align-items: center;\n}\n\n.justify-content-end {\n    justify-content: flex-end;\n}\n\n.justify-content-between {\n    justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
